import { useMediaQuery } from '@/hooks/use-media-query'

export const useIsAppContainerQuery = () => {
  return !useMediaQuery('(min-width: 768px)')
}
